function csvCell(value) {
  const rendered = String(value ?? "");
  return /[",\n\r]/.test(rendered) ? `"${rendered.replaceAll('"', '""')}"` : rendered;
}

function rowsToCsv(rows) {
  if (!rows.length) return "";
  const headers = Object.keys(rows[0]);
  return [headers.map(csvCell).join(","), ...rows.map((row) => headers.map((header) => csvCell(row[header])).join(","))].join("\r\n");
}

function text(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");
}

function date(value) {
  return String(value || "").slice(0, 10);
}

function amount(value) {
  return Number(value || 0).toFixed(2);
}

function mappedRows(provider, report) {
  const currency = report.profile?.reporting_currency || "INR";
  return (report.rows || []).map((row) => {
    const base = {
      supplier: row.vendor_name,
      supplier_tax_id: row.vendor_tax_identifier,
      bill_number: row.invoice_no,
      bill_date: date(row.invoice_date),
      due_date: date(row.invoice_date),
      purchase_order: row.po_no,
      currency: row.currency || currency,
      subtotal: amount(row.taxable_amount),
      tax: amount(row.tax_amount),
      total: amount(row.gross_amount),
      payment_reference: row.external_payment_reference,
      payment_status: row.payment_state,
    };
    if (provider === "zoho_books")
      return {
        "Vendor Name": base.supplier,
        "GST Treatment": row.vendor_country === "IN" ? "business_gst" : "overseas",
        GSTIN: base.supplier_tax_id,
        "Bill Number": base.bill_number,
        "Bill Date": base.bill_date,
        "Reference Number": base.purchase_order,
        Currency: base.currency,
        SubTotal: base.subtotal,
        "Tax Total": base.tax,
        "Total Amount": base.total,
        "Payment Reference": base.payment_reference,
      };
    if (provider === "quickbooks")
      return {
        Vendor: base.supplier,
        "Bill No": base.bill_number,
        "Bill Date": base.bill_date,
        "Due Date": base.due_date,
        Memo: `RAQOZ ${base.purchase_order}`,
        Currency: base.currency,
        "Line Amount": base.subtotal,
        "Tax Amount": base.tax,
        "Bill Total": base.total,
        "Payment Status": base.payment_status,
      };
    return {
      ContactName: base.supplier,
      InvoiceNumber: base.bill_number,
      InvoiceDate: base.bill_date,
      DueDate: base.due_date,
      Reference: base.purchase_order,
      Currency: base.currency,
      Description: `Procurement recorded in RAQOZ · ${base.purchase_order}`,
      UnitAmount: base.subtotal,
      TaxAmount: base.tax,
      InvoiceTotal: base.total,
      PaymentReference: base.payment_reference,
    };
  });
}

export function accountingFile(provider, report) {
  if (provider !== "tally")
    return {
      extension: "csv",
      mimeType: "text/csv;charset=utf-8",
      content: `\ufeff${rowsToCsv(mappedRows(provider, report))}`,
      rowCount: report.rows?.length || 0,
    };
  const vouchers = (report.rows || [])
    .map(
      (row) => `<TALLYMESSAGE xmlns:UDF="TallyUDF"><VOUCHER VCHTYPE="Purchase" ACTION="Create"><DATE>${date(row.invoice_date).replaceAll("-", "")}</DATE><VOUCHERTYPENAME>Purchase</VOUCHERTYPENAME><REFERENCE>${text(row.invoice_no)}</REFERENCE><PARTYLEDGERNAME>${text(row.vendor_name)}</PARTYLEDGERNAME><NARRATION>RAQOZ ${text(row.po_no)} · payment ${text(row.payment_state)}</NARRATION><ALLLEDGERENTRIES.LIST><LEDGERNAME>${text(row.vendor_name)}</LEDGERNAME><ISDEEMEDPOSITIVE>Yes</ISDEEMEDPOSITIVE><AMOUNT>-${amount(row.gross_amount)}</AMOUNT></ALLLEDGERENTRIES.LIST><ALLLEDGERENTRIES.LIST><LEDGERNAME>Purchase Accounts</LEDGERNAME><ISDEEMEDPOSITIVE>No</ISDEEMEDPOSITIVE><AMOUNT>${amount(row.taxable_amount)}</AMOUNT></ALLLEDGERENTRIES.LIST><ALLLEDGERENTRIES.LIST><LEDGERNAME>Input Tax</LEDGERNAME><ISDEEMEDPOSITIVE>No</ISDEEMEDPOSITIVE><AMOUNT>${amount(row.tax_amount)}</AMOUNT></ALLLEDGERENTRIES.LIST></VOUCHER></TALLYMESSAGE>`,
    )
    .join("");
  return {
    extension: "xml",
    mimeType: "application/xml;charset=utf-8",
    content: `<ENVELOPE><HEADER><TALLYREQUEST>Import Data</TALLYREQUEST></HEADER><BODY><IMPORTDATA><REQUESTDESC><REPORTNAME>Vouchers</REPORTNAME></REQUESTDESC><REQUESTDATA>${vouchers}</REQUESTDATA></IMPORTDATA></BODY></ENVELOPE>`,
    rowCount: report.rows?.length || 0,
  };
}
